import { Box, Grid, Stack, Typography } from "@mui/material";

import RichTextEditor from "components/atoms/richTextEditor/RichTextEditor";
import VoiceNotePlayBack from "components/atoms/voiceNotePlayback";
import DescriptionIcon from "@mui/icons-material/Description";

import React from "react";

import { v4 as uuidv4 } from "uuid";
import { yellow } from "@mui/material/colors";

const Comment = ({ item }) => {
  return (
    <Box
      sx={{
        maxWidth: {
          xs: "60vw",
          sm: "40vw",
          lg: "30vw",
        },

        backgroundColor: "rgba(105, 86, 229, 0.1)",
        p: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: "12px",
          width: "100%",
        }}
        className="assesment_report_comment"
        id={uuidv4()}
      >
        {item?.note?.comment}
      </Typography>
    </Box>
  );
};

const DocsNote = ({ item }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        p: 2,
        backgroundColor: "rgba(105, 86, 229, 0.05)",
        width: {
          xs: "75vw",
          sm: "45vw",
          lg: "33vw",
        },
      }}
    >
      <Stack direction={"row"} spacing={1} alignItems={"center"} sx={{ my: 2 }}>
        <DescriptionIcon sx={{ color: yellow[800] }} />
        <Typography
          sx={{ fontWeight: 700, color: "secondary.main", fontSize: "16px" }}
          className="assesment_report_title"
          id={uuidv4()}
        >
          Doctors note
        </Typography>
      </Stack>
      {item?.note?.history && (
        <RichTextEditor
          readOnly
          value={item?.note?.history}
          title={"History"}
          className="assesment_report_history"
          id={uuidv4()}
        />
      )}
      {item?.note?.examination && (
        <RichTextEditor
          readOnly
          value={item?.note?.examination}
          title={"Examination"}
          className="assesment_report_examination"
          id={uuidv4()}
        />
      )}
      {item?.note?.findings && (
        <RichTextEditor
          readOnly
          value={item?.note?.findings}
          title={"Findings"}
          className="assesment_report_findings"
          id={uuidv4()}
        />
      )}
      {item?.note?.diagnosis && (
        <RichTextEditor
          readOnly
          value={item?.note?.diagnosis}
          title={"Diagnosis"}
          className="assesment_report_diagnosis"
          id={uuidv4()}
        />
      )}
      {item?.note?.plan && (
        <RichTextEditor
          readOnly
          value={item?.note?.plan}
          title={"Plan"}
          className="assesment_report_plan"
          id={uuidv4()}
        />
      )}

      <Stack direction={"column"} spacing={2}>
        <Typography
          sx={{
            fontWeight: "700",
            color: "primary.formLabel",
            fontSize: "14px",
          }}
        >
          Voice notes
        </Typography>
        <Grid container rowSpacing={1} sx={{ mt: 1 }}>
          {item?.voiceNotes?.map((audio) => (
            <Grid item xs={12} key={audio}>
              <VoiceNotePlayBack audioUrl={audio} />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
};

const AssesmentReport = ({ item }) => {
  const isDocsNote = !item?.note?.comment;
  return <>{isDocsNote ? <DocsNote item={item} /> : <Comment item={item} />}</>;
};
export default AssesmentReport;
